import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";

function Oms(props) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentEditItem, setCurrentEditItem] = useState(null);
  const [postDescripcion, setPostDescripcion] = useState("");
  const [list, setList] = useState([]);

  const auth = {
    username: "BasicAuth@icontec.org",
    password: "yQLzqmR7eZSuAmQZUqhY",
  };

  const fetchData = () => {
    axios
      .get(
        `https://suadesarrollo.azurewebsites.net/api/QOportunidadMejoraPorIds?TareaId=${props.idTarea}&evaluadorId=0${props.idEvaluador}&SolicitudId=${props.idSolicitud}`,
        { auth },
      )
      .then((res) => setList(res.data))
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchData();
  }, [props.idTarea, props.idEvaluador, props.idSolicitud]);

  const handleOpenModal = () => {
    setIsOpen(true);
    setIsEditMode(false);
    setCurrentEditItem(null);
    setPostDescripcion("");
  };

  const handleOpenEditModal = (item) => {
    setIsOpen(true);
    setIsEditMode(true);
    setCurrentEditItem(item);
    setPostDescripcion(item.descripcion);
  };

  const closeModal = () => {
    setIsOpen(false);
    setIsEditMode(false);
    setCurrentEditItem(null);
    setPostDescripcion("");
  };

  const handleSave = async (e) => {
    e.preventDefault();

    const url = isEditMode
      ? `https://suadesarrollo.azurewebsites.net/api/EditaOmDescripcion/${currentEditItem.id}`
      : "https://suadesarrollo.azurewebsites.net/api/CreaOportunidadMejora";

    const method = isEditMode ? "put" : "post";

    try {
      await axios({
        method,
        url,
        data: {
          origen: props.nombreTarea,
          descripcion: postDescripcion,
          tareaId: props.idTarea,
          evaluadorId: props.idEvaluador,
          solicitudId: props.idSolicitud,
          institucionId: props.idInstitucion,
          estadoOportunidad: "NUEVA",
        },
        auth,
      });

      alert(isEditMode ? "OM actualizada con éxito!" : "OM creada con éxito!");

      // 🔥 refresca tabla SIN recargar
      fetchData();

      if (props.onActualizado) {
        props.onActualizado();
      }

      // 🔥 cerrar modal
      closeModal();
    } catch (error) {
      console.error(error);
      alert("Error al guardar OM");
    }
  };

  return (
    <div>
      <button className="btn btn-warning" onClick={handleOpenModal}>
        Adicionar OM
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear/Editar Om"
      >
        <div className="container">
          <div className="text-center">
            <div className="container-fluid">
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">
                    {isEditMode ? "Editar" : "Crear"} Oportunidad de mejora
                  </h6>
                </div>

                <div className="card-body">
                  <form className="user">
                    <div className="form-group row">
                      <label>
                        {isEditMode
                          ? "Edita tu Oportunidad de Mejora"
                          : "Adiciona tu Oportunidad de Mejora"}
                      </label>

                      <textarea
                        className="form-control"
                        rows="3"
                        value={postDescripcion}
                        onChange={(e) => setPostDescripcion(e.target.value)}
                      />
                    </div>

                    <button
                      className="btn btn-primary btn-user btn-block"
                      onClick={handleSave}
                    >
                      {isEditMode ? "Actualizar" : "Guardar"}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>

      {/* TABLA */}
      <div className="card-body">
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Id</th>
                <th>Descripcion</th>
                <th>Tarea</th>
                <th>Evaluador</th>
                <th>Solicitud</th>
                <th>Editar</th>
              </tr>
            </thead>
            <tbody>
              {list.map((item) => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>{item.descripcion}</td>
                  <td>{item.tarea}</td>
                  <td>{item.evaluador}</td>
                  <td>{item.solicitudId}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-primary"
                      onClick={() => handleOpenEditModal(item)}
                    >
                      Editar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Oms;
